// Robots (Google, Bing, AdSense, aperçus sociaux…) — même liste que le backend (GET /api/prerender/bots).
// Un robot qui exécute le JavaScript reçoit le HTML rendu par le serveur (/api/prerender) au lieu
// du SPA : même contenu que l'app, sans squelettes ni dialogues (« dynamic rendering », pas de cloaking).
export const BOT_UA_RE = /Googlebot|Mediapartners-Google|AdsBot-Google|APIs-Google|Google-InspectionTool|Storebot-Google|Google-Site-Verification|GoogleOther|bingbot|BingPreview|DuckDuckBot|Baiduspider|YandexBot|Applebot|facebookexternalhit|Facebot|Twitterbot|LinkedInBot|WhatsApp|TelegramBot|Slackbot|Discordbot|Pinterestbot|redditbot|Embedly|Quora Link Preview|SkypeUriPreview|vkShare|W3C_Validator|Screaming Frog|SemrushBot|AhrefsBot|MJ12bot|DotBot|PetalBot|Bytespider|GPTBot|ClaudeBot|PerplexityBot/i;

export const isBotUserAgent = (ua) => BOT_UA_RE.test(String(ua || ""));

let cached = null;
export const isBot = () => {
  if (cached === null) cached = typeof navigator !== "undefined" && isBotUserAgent(navigator.userAgent);
  return cached;
};
// Tests / QA : forcer le mode robot sans changer d'UA.
export const __setBotForTests = (v) => { cached = v; };

// Navigateur automatisé (moteur de rendu des robots : Puppeteer/Playwright, HeadlessChrome…) : sa langue
// « en-US » d'usine n'est pas une préférence → l'app le traite comme n'annonçant aucune langue (→ français par défaut).
export const isAutomatedBrowser = () =>
  typeof navigator !== "undefined" &&
  (navigator.webdriver === true || /HeadlessChrome|Prerender|Rendertron|Lighthouse/i.test(navigator.userAgent || ""));

// Routes du SPA dont le serveur sait produire une version HTML (routes_prerender.py).
export const PRERENDER_ROUTE_RE = /^\/(?:$|home$|decouvrir|discover|churches|post\/|profile\/|events?(?:\/|$)|legal(?:\/|$)|a-propos$|about$|contact$|faq$|ressources(?:\/|$)|resources(?:\/|$))/;

// Remplace le document par le HTML serveur de la route courante. Résout `false` si le serveur ne
// peut pas servir la page (le SPA se monte alors normalement).
export async function renderForBot(backendUrl) {
  const path = window.location.pathname + window.location.search;
  if (!PRERENDER_ROUTE_RE.test(window.location.pathname)) return false;
  const res = await fetch(`${backendUrl}/api/prerender?path=${encodeURIComponent(path)}`, { headers: { accept: "text/html" } });
  if (!res.ok && res.status !== 404) return false;
  const html = await res.text();
  if (!/<html/i.test(html)) return false;
  document.open();
  document.write(html);
  document.close();
  return true;
}
